import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import Immutable from "immutable";
import { createSelector } from "reselect";
import formValueSelector from "redux-form/lib/formValueSelector";
import isEqual from "lodash/isEqual";

import RecipientContext from "./RecipientContext";
import StepBox from "../StepBox";
import Overview from "../Overview";

/**
 * RecipientsStep
 */
class Index extends Component {
  static propTypes = {
    isActive: PropTypes.bool.isRequired,
    isValid: PropTypes.bool.isRequired,
    isOpen: PropTypes.bool.isRequired,
    step: PropTypes.number,
    onNextStep: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    hasOverview: PropTypes.bool,
    asyncValidate: PropTypes.func,
    onForceValidate: PropTypes.func,
    recipients: PropTypes.arrayOf(PropTypes.object).isRequired,
    recipientContexts: PropTypes.instanceOf(Immutable.List).isRequired
  };

  static defaultProps = {
    step: null,
    hasOverview: true
  };

  shouldComponentUpdate(nextProps) {
    // for some reason this does not work in the connect() "areMergedPropsEqual" option
    return !isEqual(this.props, nextProps);
  }

  render() {
    const { recipients, t, step, isOpen, isActive, isValid, onNextStep, recipientContexts } = this.props;

    if (!recipients) {
      return (
        <StepBox number={step} title={t("recipientTitle")} isActive={false} hasOverview={this.props.hasOverview} />
      );
    }

    const { length } = recipients;
    return (
      <React.Fragment>
        {recipients.map((recipient, idx) => (
          <RecipientContext
            isActive={isActive}
            isValid={isValid}
            isOpen={isOpen}
            iAmTheOneAndOnly={length === 1}
            isLastRecipient={idx + 1 === length}
            recipientCount={length}
            onNextStep={onNextStep}
            step={step}
            key={recipient.uuid}
            recipient={recipient}
            ctx={recipientContexts.get(idx)}
            ctxIdx={idx}
            onForceValidate={this.props.onForceValidate}
            asyncValidate={this.props.asyncValidate}
          />
        ))}
        {this.props.isOpen && this.props.hasOverview && <Overview />}
      </React.Fragment>
    );
  }
}

const EMPTY_LIST = Immutable.List();

const selectContext = createSelector(
  [state => state.get("context")],
  context => context
);

const selectRecipientContexts = createSelector(
  [state => selectContext(state)],
  context => (context && context.get("recipientContexts", EMPTY_LIST)) || EMPTY_LIST
);

const valueSelector = formValueSelector("cart");
export default translate()(
  connect(state => ({
    hasCustomerEmail: !!valueSelector(state, "customer.emailAddress"),
    recipients: valueSelector(state, "recipients"),
    recipientContexts: selectRecipientContexts(state.cart)
  }))(Index)
);
